"use client"

import { Sankey, Tooltip, ResponsiveContainer } from "recharts"
import { DEFAULT_PALETTE } from "./types"
import type { ChartDimension } from "./types"
import type { CSSProperties } from "react"

export interface SankeyNode { name: string }
export interface SankeyLink { source: number; target: number; value: number }

export interface SankeyChartProps {
  nodes: SankeyNode[]
  links: SankeyLink[]
  palette?: string[]
  nodePadding?: number
  nodeWidth?: number
  showTooltip?: boolean
  className?: string
  style?: CSSProperties
  height?: ChartDimension
  width?: ChartDimension
}

export function SankeyChart({
  nodes, links, palette = DEFAULT_PALETTE,
  nodePadding = 50, nodeWidth = 10, showTooltip = true,
  className, style, height = "100%", width = "100%",
}: SankeyChartProps) {
  return (
    <ResponsiveContainer width={width} height={height} className={className} style={style}>
      <Sankey
        data={{ nodes, links }}
        nodePadding={nodePadding}
        nodeWidth={nodeWidth}
        margin={{ left: 20, right: 80, top: 20, bottom: 20 }}
        link={{ stroke: palette[0], strokeOpacity: 0.4 }}
        node={{ fill: palette[1] || palette[0] }}
      >
        {showTooltip && <Tooltip cursor={{ fill: "hsl(var(--foreground) / 0.06)", stroke: "hsl(var(--muted-foreground))", strokeOpacity: 0.35 }} contentStyle={{ background: "hsl(var(--card))", border: "1px solid hsl(var(--border))", borderRadius: 6, fontSize: 11, color: "hsl(var(--card-foreground))" }} />}
      </Sankey>
    </ResponsiveContainer>
  )
}
